import styled from 'styled-components';

import { SPACE } from '@/nova/theme/tokens';

/* The ad composers' "Language" section body: the website-language picker and the hint lines under it. Sits in an
   IngredientSection body (already a column with its own gap). */

/** A hint line with something beside it: the Lumio mark before "Lumio translated ...", or "Try again" after an
 *  error. */
export const HintRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACE[8]};
`;
